import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
export function Guarantee() {
  return <section className="w-full bg-cream py-20 md:py-28" data-id="element-57" data-mp="223ejvgqjh11c">
      <div className="mx-auto max-w-3xl px-6 text-center" data-id="element-58" data-mp="222wjq90ra2o5">
        <motion.span initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mx-auto mb-8 flex h-16 w-16 items-center justify-center rounded-full bg-sage/15 text-sage" data-id="element-59" data-mp="1x3tpzkq87ivh">
          <ShieldCheckIcon size={30} strokeWidth={1.4} data-id="element-60" data-mp="qnzo2ga2gf7t" />
        </motion.span>
        <SectionHeading eyebrow="Garantía" title="7 días. Sin culpa, sin vueltas." data-id="element-61" data-mp="qlwtrk1vrzxa" />
        <div className="mt-8 space-y-5 font-sans text-base leading-relaxed text-ink-soft" data-id="element-62" data-mp="ozrosczy2i0v">
          <p data-id="element-63" data-mp="tymgk4fw3gx4">
            Si dentro de los primeros 7 días sentís que esta guía no es para
            vos, te devolvemos el 100% de lo que pagaste. Sin cuestionarios, sin
            justificar nada, sin letra chica.
          </p>
          <p data-id="element-64" data-mp="12r6c2w0vx5dq">
            Porque si hay algo que este ebook te va a enseñar, es que pedir lo
            que necesitás no tiene que darte vergüenza — y eso también aplica
            acá.
          </p>
        </div>
      </div>
    </section>;
}